import styled from "styled-components";

export const Container = styled.div`
  margin: -3rem 0 3rem;

  ${({ theme }) => theme.media.sm`
    margin: -1.6rem 0 3rem;
  `}
`;
